import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { eventTabsStyles } from "../../styles/eventTabsStyles";

const useStyles = makeStyles((theme) => eventTabsStyles(theme));


function NewEventText() {

  const classes = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '600',

      }}
      className={classes.eventTabsText}
    >
      Create Event
    </div>
  );
}

export default NewEventText;
